import { useAttentionTracker } from 'app/[locale]/hooks/useAttentionTracker';
import { useTranslate } from 'app/[locale]/hooks/useTranslate';
import Image from 'next/image';

export const Partner = (): JSX.Element => {
  const { ref } = useAttentionTracker({ sectionName: 'main_partner' });
  const { t } = useTranslate();

  return (
    <section
      className="md:px-10 md:max-w-homepage space-y-5 md:space-y-10 animate-[fadeIn_3s_ease-in-out]"
      ref={ref}
    >
      <div className="group/partnerSlider flex overflow-hidden">
        <SliderContents />
        <SliderContents />
      </div>
      <p
        dangerouslySetInnerHTML={{
          __html: t.home.HEADER_PARTNER_TEXT,
        }}
        className="text-black-light text-sm md:text-xl *:font-semibold *:text-primary text-center"
      />
    </section>
  );
};

const SliderContents = () => {
  return (
    <ul className="flex gap-6 md:gap-14 pr-6 md:pr-14 shrink-0 animate-slide group-hover/partnerSlider:[animation-play-state:paused]">
      {images.map((img, index) => (
        <li key={`partner-${index}`} className="md:p-2">
          <Image src={img.src} alt={img.alt} width={54} height={54} />
        </li>
      ))}
    </ul>
  );
};

const images = [
  { src: '/callabo/homepage/main/partner_1.png', alt: '솔루엠' },
  { src: '/callabo/homepage/main/partner_2.png', alt: '니어스랩' },
  { src: '/callabo/homepage/main/partner_3.png', alt: 'AB180' },
  { src: '/callabo/homepage/main/partner_4.png', alt: '레몬베이스' },
  { src: '/callabo/homepage/main/partner_5.png', alt: '채널톡' },
  { src: '/callabo/homepage/main/partner_6.png', alt: '캐시노트' },
  { src: '/callabo/homepage/main/partner_7.png', alt: '루나소프트' },
  { src: '/callabo/homepage/main/partner_8.png', alt: '어센트코리아' },
  { src: '/callabo/homepage/main/partner_9.png', alt: '그리팅' },
  { src: '/callabo/homepage/main/partner_10.png', alt: 'zuzu' },
];
